var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 166,
    rx: 83,
    fill: "url(#paint0_linear_347_372)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.5002 31C70.6302 31 62.4929 43.5006 62.4929 55.4456C62.4929 67.3906 70.6302 79.8792 83.5002 79.8792C96.3702 79.8792 104.508 67.3906 104.508 55.4456C104.508 43.5006 96.3702 31 83.5002 31Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 125.968H133C132.577 105.665 117.715 89.4086 98.7243 83.8286C89.5366 92.7542 77.4996 92.7904 68.2757 83.8286C49.2967 89.4207 34.4226 105.665 34 125.968Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_347_372",
    x1: 183,
    y1: 131,
    x2: 83,
    y2: 166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4780FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA6A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/user-2.6177c3eeddd7b5fece19b4c8cc960b3f.svg";
export { ForwardRef as ReactComponent };